$(document).ready(function(){
    // mascaras
    const maskProcesso = {
        mask: "0000000-00.0000.0.00.0000",
        lazy: true
    };
    const elNumProcesso = document.getElementById('numProcesso');
    const imaskProcesso = IMask(elNumProcesso, maskProcesso);

    $("#btnConsultar").click(async function(ec) {
        ec.preventDefault();
        let targetElProcessos = '#container_detalhes';
        let targetElGru = '#container_gru';
        // form
        let form = $('#frmConsultarProcesso');
        // resetar/limpar os containers a cada acionamento
        $(targetElProcessos).html('');
        $(targetElGru).html('');
        // reinicia validao do formulrio
        form.removeClass('was-validated');
        // Ativa Loading Modal
        $('#ModalLoading').modal('toggle');
        // validao padro do bootstrap
        let isBootstrapValid = bootstrapValidation();
        if(isBootstrapValid){
            // validao server-side
            //let jsonValidacoes = await serversideValidation(imaskProcesso.unmaskedValue);
            // Apresenta feedback para usurio no formulrio usando classes do boostrap
            // retorna se os valores submetidos no formulrio so verdadeiros ou falsos
            //let isFormValid = ajustaFormRetornaValidade(jsonValidacoes);
            form.addClass('was-validated');
            let consultaConcluida = await consultarDados(imaskProcesso.unmaskedValue);
            if(consultaConcluida){
                $('#ModalLoading').modal('hide');
                return false;
            }
        } else {
            $('#ModalLoading').modal('hide');
            return false;
        }
    });

    function bootstrapValidation(){
        let form = $('#frmConsultarProcesso');
        let isBootstrapValid;
        if(form[0].checkValidity()){
            isBootstrapValid = true;
        } else {
            isBootstrapValid = false;
        }
        return isBootstrapValid;
    }

    /*
    function ajustaFormRetornaValidade(jsonValidacoes){
        let isValid = JSON.parse(jsonValidacoes);
        let isAlgumCampoInvalido = null;
        if(isValid.validation_status != "nao_validado") {
            if(isValid.validation_status=="is-valid"){
                $("#numProcesso").addClass("is-valid");
                $("#numProcesso").removeClass("is-invalid");
                isAlgumCampoInvalido = false;
            }else if(isValid.validation_status=="is-invalid"){
                $("#numProcesso").addClass("is-invalid");
                $("#numProcesso").removeClass("is-valid");
                isAlgumCampoInvalido = true;
            }
        }
        return !isAlgumCampoInvalido;
    }
    */

    /** Funcoes */
    /*
    function serversideValidation(numProcesso) {
        let link = $("#linkExternoValidacao").val();
        let dados = {
            'numProcesso': numProcesso
        };
        return $.ajax({
            type: 'post',
            dataType: 'text',
            data: dados,
            url: link,
            success: function (data) {
                return data;
            }
        });
    }*/

    function consultarDados(numProcesso) {
        let targetElProc = '#container_detalhes';
        let link = $("#linkExternoConsulta").val();
        // dados a enviar via post
        var dados = {
            'numProcesso': numProcesso
        }
        return $.ajax({
            type: 'post',
            dataType: 'text',
            data: dados,
            url: link,
            success: function (data) {
                $(targetElProc).html(data);
                return true;
            }
        });
    }
});